import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'
import { UntilDestroy } from '@ngneat/until-destroy'
import { GbDashboardAuthService } from 'libs/gb-dashboard/account/utils/src/lib/gb-dashboard-auth-service/gb-dashboard-auth.service'
import { ProjectorsFacade } from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.facade'
import * as ProjectorActions from 'libs/gb-dashboard/projector/data-access/src/lib/+state/projectors.actions'
import { map } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'gb-add-projector-dialog',
  templateUrl: './gb-add-projector-dialog.component.html',
  styleUrls: ['./gb-add-projector-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAddProjectorDialogComponent {
  editCreateLoaded$ = this.projectorsFacade.editCreateLoaded$
  templateOptions$ = this.projectorsFacade.allProjectorTemplates$.pipe(
    map((templates: ProjectorTemplatesEntity[]) =>
      templates.map((template: ProjectorTemplatesEntity) => {
        return { name: template.name, value: template.uuid }
      }),
    ),
  )
  selectedProjectors$ = this.projectorsFacade.selectedProjectors$
  selectedProjectorId = ''
  addProjectorFormFields = {
    projector_name: new FormControl('', [Validators.required, Validators.maxLength(30)]),
    template_uuid: new FormControl(''),
  }
  addProjectorForm = new FormGroup(this.addProjectorFormFields)

  get projector_name() {
    return this.addProjectorForm.get('projector_name')
  }

  get template_uuid() {
    return this.addProjectorForm.get('template_uuid')
  }

  shouldShowTemplates = this.gbDashboardAuthService.isStaffSuperUserDistributor()

  constructor(
    private projectorsFacade: ProjectorsFacade,
    private gbDashboardAuthService: GbDashboardAuthService,
  ) {}

  submit() {
    this.addProjectorForm.valid ? this.save() : this.onError()
  }

  onError() {
    this.addProjectorForm.markAllAsTouched()
  }

  save() {
    this.projectorsFacade.dispatch(
      ProjectorActions.addProjector({
        name: this.projector_name?.value || '',
        templateUuid: this.template_uuid?.value || '',
      }),
    )
  }
}
